"use client";
import { NotFoundComponent } from "@/_components/ui/Error/404";
import { Box } from "@chakra-ui/react";
import { useRollbar } from "@rollbar/react";
import { usePathname } from "next/navigation";
import { useEffect } from "react";

export default function NotFound() {
  const rollbar = useRollbar();
  const pathname = usePathname();
  useEffect(() => {
    rollbar.warn(`User try to access not found route: ${pathname}`);
  }, [rollbar, pathname]);

  return (
    <Box>
      <NotFoundComponent />
    </Box>
  );
}
